import React, { useContext } from "react";
import { Context } from "../../context/Context";

/**
 * @author Thiago Guimarães
 * @date 27/01/2021
 */
function RoleControl({ children, roles, excludeRoles }) {
  const { user } = useContext(Context);

  // Se o usuário tiver uma role que está na lista de exclusão, bloqueia a exibição
  if (excludeRoles && user?.roles) {
    const hasExcludedRole = user.roles.some((role) =>
      excludeRoles.includes(role.name)
    );
    if (hasExcludedRole) {
      return null;
    }
  }

  // Verifica se o usuario possui alguma ROLE, exigida para o conteudo.
  function isRoleAllowed(userRoles, routeRoles) {
    if (userRoles && routeRoles) {
      return (
        userRoles.filter((role) => routeRoles.includes(role.name)).length > 0
      );
    }

    return false;
  }

  if (!roles || isRoleAllowed(user?.roles, roles)) {
    return <>{children}</>;
  }
  return null;
}

export default RoleControl;
